import { NodeProps } from "reactflow";
import { memo, useMemo } from "react";

import styles from "./index.less";

import NodeCard from "../NodeCard";
import Divider from "../Divider";

import RenderInput from "../render/RenderInput";
import RenderOutput from "../render/RenderOutput";
import { RenderInputProps } from "../render/RenderInput/types";

import {
  FlowModuleItemType,
  ModuleInputKeyEnum,
  VariableItemType,
} from "@packages/flow-core/module";
import { FlowNodeTypeEnum } from "@packages/flow-core/module/node/constants";
import PythonEditor from "../Editor/PythonEditor";
import { useFlow } from "../FlowEdit/useFlow";

const PythonCodeEditor = ({ item, moduleId, inputs }: RenderInputProps) => {
  const { getAllNodes, updateNodeValue, systemVariables = [] } = useFlow();

  const variables = useMemo(() => {
    const templateVariables =
      getAllNodes()
        .find((node) => node.data.flowType === FlowNodeTypeEnum.templateParam)
        ?.data?.inputs.map((item) => ({
          key: item.key,
          label: item.label,
          isTemplateVariable: true,
        })) || [];
    const globalVariablesModule: Pick<VariableItemType, "key" | "label">[] =
      getAllNodes()
        .find((node) => node.data.flowType === FlowNodeTypeEnum.globalVariable)
        ?.data?.inputs.filter((input) => input.edit)
        .map((item) => ({ key: item.key, label: item.label })) || [];
    const moduleVariablesModule: Pick<VariableItemType, "key" | "label">[] =
      inputs
        ?.filter((input) => input.edit)
        .map((item) => ({
          key: item.key,
          label: item.description || item.label,
          self: true,
        })) || [];

    return [
      ...templateVariables,
      ...globalVariablesModule,
      ...moduleVariablesModule,
      ...systemVariables,
    ];
  }, [getAllNodes, systemVariables, inputs]);

  const handleChange = (v: string) => {
    updateNodeValue(moduleId, item.key, v);
  };

  return (
    <PythonEditor
      value={item.value as string}
      onChange={handleChange}
      variables={variables}
    />
  );
};

export default memo(function NodeCodeRunner({
  data,
  selected,
}: NodeProps<FlowModuleItemType>) {
  const { inputs, moduleId, outputs } = data;

  return (
    <NodeCard minWidth={500} selected={selected} {...data}>
      <>
        <Divider text="输入" />
        <div className={styles.content}>
          <RenderInput
            flowInputList={inputs}
            moduleId={moduleId}
            CustomComponent={{
              [ModuleInputKeyEnum.pythonCode]: PythonCodeEditor,
            }}
          />
        </div>
      </>
      <>
        <Divider text="输出" />
        <div className={styles.content}>
          <RenderOutput flowOutputList={outputs} moduleId={moduleId} />
        </div>
      </>
    </NodeCard>
  );
});
